
const aesjs = require('aes-js')
const pbkdf2 = require('pbkdf2')
const localforage = require('localforage')

function isObject(o) {
  return o instanceof Object && o.constructor === Object
}

module.exports = ['$rootScope', function ($rootScope) {
  const IndexedDB = {
    config(uid) {
      this.uid = uid
      this.ready = false
      this.store = null
      if (!uid) {
        console.warn('uid is required')
      } else {
        this.store = localforage.createInstance({
          driver: localforage.INDEXEDDB,
          name: 'Hxphone',
          version: 2.0,
          storeName: 'hxphone_store_' + uid,
          description: 'Hxphone Store System'
        })
        this.ready = true
      }
    },
    isReady() {
      return this.ready
    },
    enableCacheEncrypt() {
      return $rootScope.settings.mailCacheEncrypt
    },
    setItem(key, value) {
      if (this.enableCacheEncrypt()) {
        const rawText = JSON.stringify(value)
        const encryptedText = this._aesjs.encrypt(this._aesjs.generateKey(this.uid), rawText)
        value = {
          encrypt: encryptedText
        }
      }
      return this.store.setItem(key, value)
    },
    getItem(key) {
      return this.store.getItem(key).then(cache => {
        if (isObject(cache) && cache.encrypt) {
          const decryptedText = this._aesjs.decrypt(this._aesjs.generateKey(this.uid), cache.encrypt)
          try {
            return JSON.parse(decryptedText)
          } catch (error) {
            return null
          }
        } else {
          return cache
        }
      })
    },
    removeItem(key) {
      this.store.removeItem(key)
    },
    clear() {
      this.store.clear()
    },
    key() {
      return this.store.key()
    },
    keys() {
      return this.store.keys()
    },
    length() {
      return this.store.length()
    },
    // aesjs加密工具
    _aesjs: {
      /**
       * @function 对aesjs加密过程的封装
       * @param {array} key 密钥
       * @param {string} text 准备加密的字符串
       * @retuns 返回经过加密的字符串
       */
      encrypt(key, text) {
        try {
          const textBytes = aesjs.utils.utf8.toBytes(text)
          const aesCtr = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(1)) // eslint-disable-line
          const encryptedBytes = aesCtr.encrypt(textBytes)
          const encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes)
          return encryptedHex
        } catch (error) {
          console.warn('加密出错，无法缓存数据', `error:${error}`)
          return null
        }
      },
      /**
       * @function 对aesjs解密过程的封装
       * @param {array} key 密钥
       * @param {string} encryptedHex 准备解密的字符串
       * @returns 返回经过解密的字符串
       */
      decrypt(key, encryptedHex) {
        try {
          const encryptedBytes = aesjs.utils.hex.toBytes(encryptedHex)
          const aesCtr = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(1)) // eslint-disable-line
          const decryptedBytes = aesCtr.decrypt(encryptedBytes)
          const decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes)
          return decryptedText
        } catch (error) {
          console.warn('解密出错，无法获取缓存数据', `error:${error}`)
          return null
        }
      },
      /**
       * @function 生成128bit密钥
       * @param {string} text 生成128bit密钥的原始文本
       * @returns 返回密钥
       */
      generateKey(text) {
        const key = pbkdf2.pbkdf2Sync(text, 'salt', 1, 128 / 8, 'sha512')
        return key
      }
    }
  }
  return IndexedDB
}]



// WEBPACK FOOTER //
// ./src/js/infrastructure/IndexedDB.js